import { ReactNode } from 'react'
import { LinkAnchor } from './LinkAnchor'

export const LinkWrapper = ({
  to,
  children,
}: {
  to: string
  children: ReactNode
}) => {
  return (
    <LinkAnchor
      to={to}
      style={{
        textDecoration: 'none',
      }}
    >
      {children}
    </LinkAnchor>
  )
}
